// flow-reference.component.ts
import { Component, OnInit, Input } from "@angular/core";
import { CallflowsDesignComponent } from "../../../callflows-design.component";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { DataService } from "../../../../@core/utils/data.service";
import { CallFlowClient } from "../../../../System-api";
@Component({
  selector: "app-flow-reference",
  templateUrl: "./flow-reference.component.html",
  styleUrls: ["./flow-reference.component.scss"],
})
export class FlowReferenceComponent implements OnInit {
  selectedItem: any = null;
  flowRelationships: any[] = [];
  flowRelationshipsFilter: any[] = [];
  subFlowRelationships: any[] = [];
  subFlowRelationshipsFilter: any[] = [];
  searchText: string = "";
  searchSubText: string = "";
  callFlowUrl: string = "";
  isLoading = false;
  constructor(
    protected ref: NbDialogRef<FlowReferenceComponent>,
    private dataService: DataService,
    public dialogService: NbDialogService,
    private router: Router,
    private callFlowClient: CallFlowClient
  ) {}
  dismiss() {
    this.ref.close(false);
  }
  ngOnInit() {
    this.isLoading = true;
    this.callFlowClient
      .getFlowReference(this.dataService.CallFlow.id)
      .subscribe({
        next: (rs) => {
          this.isLoading = false;
          if (rs) {
            this.flowRelationships = rs.mainFlow;
            this.flowRelationshipsFilter = rs.mainFlow;
            this.subFlowRelationships = rs.subFlow;
            this.subFlowRelationshipsFilter = rs.subFlow;
          }
        },
        error: (error) => {
          this.isLoading = false;
        },
      });
  }

  clickedRow(item: any) {}

  openFlow(item) {
    this.router.navigate([]).then((result) => {
      window.open(`/callflow-design/${item.id}`, "_blank");
    });
  }

  filterFlows() {
    if (this.searchText) {
      this.flowRelationships = this.flowRelationshipsFilter.filter((item) =>
        item.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    } else {
      this.flowRelationships = this.flowRelationshipsFilter;
    }
  }
  filterSubFlows() {
    if (this.searchSubText) {
      this.subFlowRelationships = this.subFlowRelationshipsFilter.filter(
        (item) =>
          item.name.toLowerCase().includes(this.searchSubText.toLowerCase())
      );
    } else {
      this.subFlowRelationships = this.subFlowRelationshipsFilter;
    }
  }
}
